import { render, staticRenderFns } from "./ImageRoll.vue?vue&type=template&id=30d176f0"
import script from "./ImageRoll.vue?vue&type=script&lang=js"
export * from "./ImageRoll.vue?vue&type=script&lang=js"
import style0 from "./ImageRoll.vue?vue&type=style&index=0&id=30d176f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/opt/build/repo/components/base/BaseImage.vue').default})
